export function getFilename(lensUri: string) {
    return lensUri.substring(lensUri.lastIndexOf("/") + 1);
}
